var map = {
	"./AOffer/Ltr.css": 1011,
	"./AOffer/Rtl.css": 1012,
	"./ASKERI/Ltr.css": 1013,
	"./ASKERI/Rtl.css": 1014,
	"./Swiftee/Ltr.css": 1015,
	"./Swiftee/Rtl.css": 1016,
	"./Swiftee/colors.css": 1017,
	"./default/Ltr.css": 590,
	"./default/Rtl.css": 591,
	"./default/colors.css": 592,
	"./latreqi/Ltr.css": 1018,
	"./latreqi/Rtl.css": 1019,
	"./sassColors/Anypoint.css": 1020,
	"./sassColors/BeyondDelivery.css": 1021,
	"./sassColors/CouriersExpress.css": 1022,
	"./sassColors/EaglePost.css": 1023,
	"./sassColors/Geshikt.css": 1024,
	"./sassColors/Jora.css": 1025,
	"./sassColors/Kiosken.css": 1026,
	"./sassColors/Kwikr.css": 1027,
	"./sassColors/Maydaycourier.css": 1028,
	"./sassColors/Ondelivery.css": 1029,
	"./sassColors/ParcelBeep.css": 1030,
	"./sassColors/PinkExpress.css": 1031,
	"./sassColors/Privitrides.css": 1032,
	"./sassColors/Reflexcourier.css": 1033,
	"./sassColors/Snapbox.css": 1034,
	"./sassColors/Solutions1000.css": 1035,
	"./sassColors/Swishr.css": 1036,
	"./sassColors/TheTruckingForme.css": 1037,
	"./sassColors/landeber.css": 1038,
	"./sassColors/mannaev.css": 1039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;